import { PermissionType } from '../contracts/permissions.js';
export function getLeastPrivilegedPermission(...permissions) {
    return PermissionType[permissions
        .values()
        .map((x) => (x === null || x === undefined ? -1 : PermissionType.indexOf(x)))
        .min()];
}
export function getMostPrivilegedPermission(...permissions) {
    return PermissionType[permissions
        .values()
        .map((x) => (x === null || x === undefined ? -1 : PermissionType.indexOf(x)))
        .max()];
}
/**
 * @deprecated this method should almost never be used, prefer `doesAccessGrantAllowRequest`
 */
export function comparePermissions(a, b) {
    const aIdx = a ? PermissionType.indexOf(a) : -1;
    const bIdx = b ? PermissionType.indexOf(b) : -1;
    return aIdx - bIdx;
}
export function doesAccessGrantAllowRequest(grant, request) {
    if (!grant)
        return false;
    if (!request)
        return true;
    return PermissionType.indexOf(grant) >= PermissionType.indexOf(request);
}
export function getPermissionSetTypeForPermissionType(type) {
    return `${type}s`;
}
export function getPermissionTypeForPermissionSetType(type) {
    return type.slice(0, -1);
}
//# sourceMappingURL=permissions.js.map